import { lazy } from 'react';
import Order from './order-list/Order';
import CreateOrder from './create-order/CreateOrder';
import ViewOrder from './view-order/ViewOrder';
import OrderList from './order-list/OrderList';
import OrderDetails from './view-order/OrderDetails';
import PartOrder from './create-order/PartOrder';
import EditOrder from './edit-order/EditOrder';
import Dashboard from './Dashboard';
import NewOrderList from './order-list/NewOrderList';
import NewABsList from './order-list/NewABsList';
import AmendmentRequestList from './order-list/AmendmentRequestList';
import RevisedABsList from './order-list/RevisedABsList';
import CustomerConfList from './order-list/CustomerConfList';
import BookingReqList from './order-list/BookingReqList';
import OrderContainerList from './order-list/OrderContainerList';
import PendingABsList from './order-list/PendingABsList';
import PRJOrderSummary from './create-order/PRJOrderSummary';
import CustomerOrder from './order-list/CustomerOrderList';
import TestOrder from './create-order/PrjOrder';
import EditABFile from './view-order/EditABFile';
import AbsWithoutOrder from './order-list/AbsWithoutOrder';
import UnConfirmedOrders from './order-list/UnConfirmedOrders';
import CreateAbsOrder from './create-order/CreateAbsOrder';
import CreateAbsPartOrder from './create-order/CreateAbsPartOrder';
import CreateTypePartOrder from './create-order/CreateTypePartOrder';
import SpecialProjectOrder from './create-order/SpecialProjectOrder';
import SpecialPRJOrderSummary from './create-order/SpecialPRJOrderSummary';
import BulkPartOrder from './create-order/BulkPartOrder';
import BulkPartOrderSummary from './create-order/BulkPartOrderSummary';

const OrderConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/order/dashboard',
            element: <Dashboard />,
        },
        {
            path: '/order',
            element: <Order />,
        },
        {
            path: '/order/new-order-list',
            element: <NewOrderList />,
        },
        {
            path: '/order/new-abs-list',
            element: <NewABsList />,
        },
        {
            path: '/order/amendment-request-list',
            element: <AmendmentRequestList />,
        },
        {
            path: '/order/revised-abs-list',
            element: <RevisedABsList />,
        },
        {
            path: '/order/customer-conf-list',
            element: <CustomerConfList />,
        },
        {
            path: '/order/booking-req-list',
            element: <BookingReqList />,
        },
        {
            path: '/order/order-container-list',
            element: <OrderContainerList />,
        },
        {
            path: '/order/pending-abs-list',
            element: <PendingABsList />,
        },
        {
            path: '/order/unconfirmed-order',
            element: <UnConfirmedOrders />,
        },
        {
            path: '/order/create-order',
            element: <CreateOrder mode="new" />,
        },
        {
            path: '/order/edit-order/:id',
            element: <CreateOrder mode="edit" />,
        },
        {
            path: '/order/new-type-order/:id',
            element: <CreateOrder mode="new-type" />,
        },
        {
            path: '/order/new-type-part-order/:id',
            element: <CreateTypePartOrder />,
        },
        {
            path: '/order/create-part-order',
            element: <PartOrder />,
        },
        {
            path: '/order/special-project-order',
            element: <SpecialProjectOrder mode="new" />,
        },
        {
            path: '/order/special-project-order-summary',
            element: <SpecialPRJOrderSummary />,
        },
        {
            path: '/order/bulk-part-order',
            element: <BulkPartOrder />,
        },
        {
            path: '/order/bulk-part-order-summary',
            element: <BulkPartOrderSummary />,
        },
        {
            path: '/order/order-list',
            element: <OrderList />,
        },
        {
            path: '/order/customer-order',
            element: <CustomerOrder />,
        },
        {
            path: '/order/test-order',
            element: <TestOrder />,
        },
        {
            path: '/order/view-order/:id',
            element: <ViewOrder />,
        },
        {
            path: '/order/order-details/:id',
            element: <OrderDetails />,
        },
        {
            path: '/order/project-order-details/:id',
            element: <OrderDetails />,
        },
        {
            path: '/order/edit-order',
            element: <EditOrder />,
        },
        {
            path: '/order/project-order',
            element: <PRJOrderSummary />,
        },
        {
            path: '/order/editABFile/:id',
            element: <EditABFile />,
        },
        {
            path: '/order/abs-without-order',
            element: <AbsWithoutOrder mode="new" />,
        },
        {
            path: '/order/create-abs-order',
            element: <CreateAbsOrder mode="new"/>,
        },
        {
            path: '/order/create-abs-part-order',
            element: <CreateAbsPartOrder />,
        },
    ],
};

export default OrderConfig;
